/**
 * Mirrors WebApi Models.Common.NewViewerBackend.ProjectManagementTabType — the status tabs of
 * the admin "אישור פרויקטים" screen. Numeric, like ManagementTabType for support requests.
 *
 * A tab is not a status: "ממתין לאישור" aggregates the three review sub-stages, and the SERVER
 * maps a tab to its statuses (ProjectStatusDefinitions.Tabs), so the client just names the tab.
 * An unknown value returns 400.
 */
export enum ProjectManagementTabType {
  /** ממתין לאישור — all three review sub-stages. */
  PendingApproval = 1,
  /** מאושר */
  Approved = 2,
  /** נדחה */
  Rejected = 3,
}
